import assetPath from '/opt/actions-runner/_work/crate/crate/packages/startpage-logged-out/native-apps-section/src/assets/background.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')